<template>
  <div>
    <picture-in-picture ref="pic-pic" @hook:mounted="picPicZindex(9999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" :selectedFile="selectedFileInfo"  @closeMiniPlayer="closeMinimisedPlayer"  :disablePreviewDocker="true"></picture-in-picture>
    <ImagePreviewDialog ref="fullscreen-pic" @hook:mounted="picPicZindex(9999, 'fullscreen-pic')" class="hide-element-util-mount" v-cloak @maximisePlayer="showAssetDetailsDockCloseMiniplayer" :selectedFile="selectedFileInfo" @closeMiniPlayer="closeMinimisedPlayer"
    v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-2">
            <h6 class="modal-title">{{$t('Properties')}}</h6>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true">
                <cancel-icon class="close-icon" style="height: 30px !important;
                  width: 30px !important;
                  color: #fff;">
                </cancel-icon>
              </span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="h-100">
                <nav v-if="selectedFileInfo.file_type != 'folder' && (('asset_type' in selectedFileInfo && selectedFileInfo.asset_type != 'catalog') || !selectedFileInfo.asset_type)" class="navbar navbar-expand-lg p-0">
                    <div class="collapse navbar-collapse" id="navbarNavAltMarkup" style="cursor: pointer;">
                      <div class="navbar-nav w-100 top-nav-bar">
                          <a class="nav-item nav-link"  v-for="panel in [...getRegisteredPropertiesTopNav(),...tabsList]" v-on:click="getEventHandler('onClick',panel.onEvents,panel);" :key="panel.label" :class='(activeIndex === panel.label)?"active":"inactive"' style="width:140px">{{$t(panel.label)}}<span class="sr-only">(current)</span></a>
                      </div>
                    </div>
                </nav>
                <component :is="selectedComponent" v-bind="currentProperties" @playTranscript="playTranscript" @previewVersions="previewVersions" @previewLinkedAsset="viewLikedAssetProxy" @openInCatalog="openAssetInCatalog"></component>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MiniPlayer @closeMiniPlayer="isMiniPlayerVisible = false" :autoPlay="miniPlayerAutoPlay" v-if="isMiniPlayerVisible" :transcriptPlayObject="transcriptPlayObject" ref="miniPlayerRef"  :selectedFile="fileInfo"></MiniPlayer>
    <OpenCatalogBrowse v-if="enableOICBrowse" @close="enableOICBrowse=false" @traverToCatalog="setRouterUrl" :pIPList="parentIPList"></OpenCatalogBrowse>
  </div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue";
import basicProperties from "../properties/BasicProperties.vue";
//import AssetVersionsDetails from "../ManageVersions/ManageVersion.vue"
// import AssetVersionsDetails from "../properties/AssetVersionsView.vue"
import externalPluginProperties from "../properties/ExternalPluginProperties.vue";
import {PropertiesTopNav} from "../../registry/plugins.js"
import MiniPlayer from '../files/MiniPlayer.vue';
import {mapGetters,mapMutations, mapActions} from "vuex"
import Utils from "../../components.utils.js"
import pictureInPicture from "../files/MiniPlayer.vue";
import imagePreview from "../core/ImagePreviewDialog.vue";
import Constants from "../../components.constants.js";
import mediaLog from "../properties/MediaLog.vue";
import technicalProperties from "../properties/TechicalMetadata.vue"
import OpenCatalogBrowse from "../categories/OpenInCatalogBrowse.vue";

export default {
  props:["fileInfo", "context",'isCloseModalWithoutRouteChange'],
  data(){
    return{
        topNavList:[],
        selectedPluginInfo:null,
        activeIndex: "Metadata",
        selectedComponent:"basic-properties",
        selectedFileInfo : null,
        transcriptPlayObject:{},
        isMiniPlayerVisible: false,
        openPip:false,
        showOtherFilesPreviewDialog:false,
        assetDetailsToShowPip:{},
        parentRouteInfo:{},
        enableOICBrowse:false,
        selectedAssetId:"",
        parentIPList:[],
        miniPlayerAutoPlay:false,
        tabsList:[],
    }
  },
  computed:{
    barcodeInfoFromStartup:{
        get(){
            return this.$store.state.startUpData.startUpDataDetails;
        }
    },
    currentProperties() {
      if (["basic-properties","media-log", "technical-metadata"].includes(this.selectedComponent)) {
        if (Object.keys(this.selectedFileInfo).length == 0){
          return { fileInfo: this.fileInfo , context: this.context};
        }else{
          return { fileInfo: this.selectedFileInfo , context: this.context};
        }
      }else if (this.selectedComponent === "external-plugin-properties") {
        return { pluginInfo : this.selectedPluginInfo, extraInfo:this.selectedFileInfo};
      }else if (this.selectedComponent === "asset-version-details") {
        // return { assetId : this.selectedFileInfo.asset_id};
        if (!this.fileInfo || Object.keys(this.fileInfo).length == 0){
          return { fileInfo: this.selectedFileInfo , context: this.context};
        }else{
          return { fileInfo: this.fileInfo , context: this.context};
        }
      } else if(typeof this.selectedComponent == 'object') {
          if (!this.fileInfo || Object.keys(this.fileInfo).length == 0){
            return { fileInfo: this.selectedFileInfo , context: this.context};
          }else{
            return { fileInfo: this.fileInfo , context: this.context};
          }
      }else{
         return {};
      }
    },
  },
   components:{
        'cancel-icon':cancelIcon,
        'basic-properties':basicProperties,
        'technical-metadata':technicalProperties,
        'external-plugin-properties':externalPluginProperties,
        //'asset-version-details':AssetVersionsDetails,
        MiniPlayer,
        "picture-in-picture":pictureInPicture,
        "ImagePreviewDialog":imagePreview,
        "media-log":mediaLog,
        OpenCatalogBrowse
    },
    methods:{
      openAssetInCatalog(file){
        this.parentIPList = [];
        if(file.asset_type == "subclip" &&  "master_asset_id" in file &&
          file.master_asset_id != undefined && file.master_asset_id.length > 0){
          this.selectedAssetId = file.master_asset_id;
        }else{
          this.selectedAssetId = file.asset_id
        }
        if(this.selectedAssetId){
          this.eOMenu = !this.eOMenu;
          let payload = {params:{assetId: this.selectedAssetId}}
          this.getAssetInfoFromServer(payload).then((data) => {
            if (data.statusCode==200){
              let selectedAssetDetails = data["asset"];
              if(selectedAssetDetails){
                if("parent_id_path" in selectedAssetDetails &&
                  selectedAssetDetails.parent_id_path.length > 0){
                  this.parentIPList = selectedAssetDetails.parent_path;
                  if(selectedAssetDetails.parent_id_path.length == 1){
                    let pIPath = selectedAssetDetails.parent_id_path[0]
                    let cIdList = pIPath.split("/");
                    let catInfo = this.parentIPList[0];
                    this.setRouterUrl(cIdList[cIdList.length - 1],catInfo[catInfo.catalog_name], selectedAssetDetails.catalog_type)
                  }else{
                    this.enableOICBrowse = true;
                  }
                }
              }else{
                alert("Unable to open asset in Catalog. ")
                return
              }
            }else{
              this.$toast.error(data.message);
            }
          })
        }
      },
      setRouterUrl(catalogId, catalogName, catalogType){
        Utils.updateCookieByKeyName("context","catalogs-display");
        let query = {advanceFilter:JSON.stringify({fields:JSON.stringify({}), asset_id:this.selectedAssetId})}
        if(this.barcodeInfoFromStartup.enable_department){
          query = {advanceFilter:JSON.stringify({fields:{}, asset_id:this.selectedAssetId}), 'projects':'all', 'fromchild':true}
          Utils.setLocalStorageValue('selectedDepartmentsArr', JSON.stringify(['all']))
        }
        this.$router.push({
          name:"catalogs-display",
          params:{
                  _id: catalogId, 
                  catalog_name: catalogName,
                  catalog_id: catalogId,
                  catalog_type: catalogType
                },
          query: query
        })
        this.$emit("openAdvancedSearch")
        this.enableOICBrowse = false;
      },
      playTranscript(transcript){
         this.transcriptPlayObject = transcript;
         this.miniPlayerAutoPlay = true;
         if(!this.isMiniPlayerVisible) this.isMiniPlayerVisible = true;
         this.$nextTick(()=>{
            if(this.getAssetDetailsPlayer()){
                this.getAssetDetailsPlayer().player.pause();
            }
            this.miniPlayerAutoPlay = true;
         });
      },
      close(){
        if(this.isCloseModalWithoutRouteChange){ //will not interfere with existing code
           this.$emit("close")
           return;
        }
        this.$emit("close")
        if (Object.keys(this.parentRouteInfo).length!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
          this.$router.replace({
            name: this.parentRouteInfo.name,
            params:this.parentRouteInfo.params,
            query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
          })
        }else{
          this.$router.replace({
            name: "explorer",
          })
        }
      },
      changeComponent(comp,label){
        this.activeIndex =  label,
        this.selectedComponent = comp;
      },
      changeComponentToBasicProperties(){
          this.changeComponent("basic-properties","Metadata")
      },
      changeComponentToTechnicalMetadataProperties(){
          this.changeComponent("technical-metadata", "Technical Metadata");
      },
      changeComponentToVerisonProperties(){
        this.changeComponent("asset-version-details","Versions")
      },
      changeComponentToMediaLog(){
        this.changeComponent("media-log","Media Log")
      },
      setUpPropertiesTopNavList(topNavList){
          for (let topNav of topNavList) {
            if (topNav == "properties"){
              let basicPropertiesEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToBasicProperties,
                "handler_args":""
              }]
              let basicProperties = new PropertiesTopNav("properties", "properties", "Metadata",basicPropertiesEvents)
              basicProperties.register()
            }else if (topNav == "Technical metadata"){
              let techMetPropertiesEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToTechnicalMetadataProperties,
                "handler_args":""
              }]
              let techMetProperties = new PropertiesTopNav("Technical Metadata", "Technical Metadata", "Technical Metadata",techMetPropertiesEvents)
              techMetProperties.register()
            }else if (topNav == "versions" && this.selectedFileInfo && this.selectedFileInfo.asset_type && ['file', 'page'].includes(this.selectedFileInfo.asset_type)){
              let versionsPropertiesEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToVerisonProperties,
                "handler_args":""
              }]
              let basicProperties = new PropertiesTopNav("versions", "versions", "Versions",versionsPropertiesEvents)
              basicProperties.register()
            }else if (topNav == "media log"  && this.selectedFileInfo && this.selectedFileInfo.asset_type && ['file','page'].includes(this.selectedFileInfo.asset_type)){
              let mediaLogPropertiesEvent = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToMediaLog,
                "handler_args":""
              }]
              let basicProperties = new PropertiesTopNav("media log", "media log", "Media Log",mediaLogPropertiesEvent)
              basicProperties.register()
            }   
          }
        },
        getEventHandler(eventname,supportedEvents,pluginInfo){
            this.selectedPluginInfo = null;
            if(pluginInfo && Object.prototype.hasOwnProperty.call(pluginInfo, 'registrationType') && pluginInfo.registrationType == 'propertiesTab'){
               let comp = null;
               if(Object.prototype.hasOwnProperty.call(pluginInfo, 'renderComponent')){
                  comp = pluginInfo.component[pluginInfo.renderComponent];
               }else{
                 comp = pluginInfo.component;
               }
               this.selectedPluginInfo = Object.assign({}, pluginInfo);
               this.changeComponent(comp,pluginInfo.label);
               return;
            }
            if (pluginInfo){
                if(pluginInfo.label == "Metadata"){
                    return this.changeComponentToBasicProperties()
                }else if(pluginInfo.label == "Technical Metadata"){
                  return this.changeComponentToTechnicalMetadataProperties()
                }else if(pluginInfo.label == "Versions"){
                  return this.changeComponentToVerisonProperties();
                }else if( pluginInfo.label == "Media Log"){
                  return this.changeComponentToMediaLog()
                }
                else{
                    this.selectedPluginInfo = Object.assign({}, pluginInfo)
                    return this.changeComponent("external-plugin-properties",pluginInfo.label,)
                }
            }else{
                let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
                if(event.length != 0){
                    return event[0]["event_handler"]();
                }
            }
        },
        isEnabled(priv) {
          return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), priv);
        },
        picPicZindex(zvalue, ref){
          if(this.$refs[ref].$el.style)this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
        },
        showAssetDetailsDockCloseMiniplayer(){
            if(this.showOtherFilesPreviewDialog) this.showOtherFilesPreviewDialog = false;
            this.openPip = true;
        },
        showAssetDetailsDockCloseMaximisedplayer(){
            if(this.isFullscreenPreviewAllowed()){
                this.openPip = false;
                this.showOtherFilesPreviewDialog = true;
                return;
            }
        },
        openPictureInPicture(){
          if(this.isFullscreenPreviewAllowed()){
            this.openPip = false;
            this.showOtherFilesPreviewDialog = true;
            return;
          }else{
            this.openPip = true;
            this.showOtherFilesPreviewDialog = false;
          }
        },
        isFullscreenPreviewAllowed(){
            let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
            return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.selectedFileInfo)) > -1
        },
        viewLikedAssetProxy(fileInfo){
          if(fileInfo){
            this.selectedFileInfo = {};
            this.selectedFileInfo = fileInfo;
            this.openPictureInPicture()
          }
        },
        previewVersions(fileInfo){
            this.selectedFileInfo = {};
            this.selectedFileInfo = fileInfo;
            if(fileInfo.files[0] && fileInfo.files[0].path)this.selectedFileInfo['file_name'] = fileInfo.files[0].path.split("/")[fileInfo.files[0].path.split("/").length - 1]
            this.$nextTick(() => {
              this.openPictureInPicture()
            })
        },
        closeMinimisedPlayer(){
            this.openPip = false;
            this.showOtherFilesPreviewDialog = false;
        },
      ...mapGetters("users",["getLoggedInUserId","getLoggedInUserPrivilege","getIsAssetsDetailsPanelVisible"]),
      ...mapGetters("registry",["getRegisteredPropertiesTopNav","getPropertiesTabPlugins"]),
      ...mapMutations("registry",["registerPropertiesTopNav","unsetPropertiesTopNav","unsetOnlySelectedPropertiesTopMenu"]),
      ...mapGetters("assets",["getAssetDetailsPlayer"]),
      ...mapActions("assets",["getAssetInfoFromServer"])
    },
    async created(){
      Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
      let fileInfo = {};
      if(this.$route.params.fileInfo && Object.keys(this.$route.params.fileInfo).length > 0){
        this.selectedFileInfo = Object.assign({},this.$route.params.fileInfo);
      }else if (this.fileInfo != undefined && Object.keys(this.fileInfo).length > 0){
        this.selectedFileInfo = Object.assign({},this.fileInfo);
      }else{
        let data = await this.getAssetInfoFromServer({params:{assetId:this.$route.params.assetId}})
        this.selectedFileInfo = Object.assign({}, data.asset);
      }
      fileInfo = this.selectedFileInfo;
      /*
      if(this.isEnabled('Manage Version') && fileInfo && fileInfo.asset_type && fileInfo.asset_type == 'file'){
        if(!this.topNavList.includes("versions")){
          this.topNavList.push("versions")
        }
      }else{
        this.topNavList = this.topNavList.filter(e => e != 'versions');
        this.unsetOnlySelectedPropertiesTopMenu('versions')
      }*/

      if(this.isEnabled('Media Pipeline') && fileInfo && fileInfo.asset_type && ['file','page'].includes(fileInfo.asset_type)){
        if(!this.topNavList.includes("media log")){
          this.topNavList.push("media log")
        }
      }else{
        this.topNavList = this.topNavList.filter(e => e != 'media log');
        this.unsetOnlySelectedPropertiesTopMenu('media log')
      }
      if('asset_type' in fileInfo && ['catalog'].includes(fileInfo.asset_type)){
        console.log("Skipped Technical Metadata for asset type catalog");
      }else{
        this.topNavList.push('properties');
        this.topNavList.push('Technical metadata');
      }
      this.setUpPropertiesTopNavList(this.topNavList);

      try{
          for(let i = 0; i < this.getPropertiesTabPlugins().length; i++){
                let pInfo = this.getPropertiesTabPlugins()[i];
                console.log("Properties Tab Plugin Info: ", pInfo);
                // if(pInfo && Object.prototype.hasOwnProperty.call(pInfo,'evalCondition') &&  typeof pInfo.evalCondition == 'function'){
                //   if(!pInfo.evalCondition(this)){
                //     return;
                //   }
                // }
                if(pInfo &&  Object.prototype.hasOwnProperty.call(pInfo,'pluginBundle') && pInfo.pluginBundle.js){
                  let respData = await Utils.loadPluginBundles([pInfo.pluginBundle.js],pInfo.componentLoadedEventName);
                  if(respData && respData.length > 0){
                    let pData = respData[0];
                    if(pData.pluginStore && Array.isArray(pData.pluginStore) && pData.pluginStore.length){
                        for(let i = 0; i < pData.pluginStore.length; i++){
                          if(!this.$store.hasModule(pData.pluginStore[i].module))
                            this.$store.registerModule(pData.pluginStore[i].module,pData.pluginStore[i].store); // registers store dynamically at run time
                        }
                    }else{
                      if(pData.pluginStore && !this.$store.hasModule(pData.pluginStore.module))
                          this.$store.registerModule(pData.pluginStore.module,pData.pluginStore.store); // registers store dynamically at run time
                    }
                    Utils.loadCssBundle(pInfo.pluginBundle.css);
                    this.tabsList.push({
                      component: pData.components,
                      ...pInfo
                    });
                  }
                }
          }
      }catch(e){console.log(e)}
    },
    beforeDestroy(){
      this.transcriptPlayObject = {};
    }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 66%;
    width: 66%;
    height: 70%;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
     background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      user-select: text !important; 
      cursor:text;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 10%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}


.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
} 

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    justify-content: flex-start;
    button{
        height: 35px;
        width: 70px;
    font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.nav-item{
    color: $dull-text-color !important;
}
.inactive:hover{
  color:$text-color !important;
}
.active{
    background: $primary-background !important;
    color:$active-blue  !important;
    border-bottom: 2px solid $active-blue ;
}
.top-nav-bar{
    text-align: center;
    background: $primary-background;
    justify-content: space-around;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

  .media-preview-modal{
    top: 0px !important;
  }
</style>
